import ApiBaseModel from "@/common/models/ApiBaseModel";
import { StationTypes, LocationProcessorTypes } from "@/common/enums";

export default class LocationModel extends ApiBaseModel {
    locationIdPrevious: number = 0;
    locationId: number = 0;
    siteName: string = "";
    siteSetting: string = "";    
    latitude: number = 0;
    longitude: number = 0;
    merchantInfo: string | null = "";
    chaseSettings: chaseSettingsModel = new chaseSettingsModel()
    pineappleMerchantId: string = ""
    
    locationProcessorType: LocationProcessorTypes = LocationProcessorTypes.Unknown

    get _locationProcessorType(): LocationProcessorTypes {
        if (this.merchantInfo! == null)
            return LocationProcessorTypes.Unknown

        if (this.merchantInfo!.includes("__private_id") && this.merchantInfo!.includes("chase_setting_model"))
            return LocationProcessorTypes.Chase
        else if (this.merchantInfo!.length > 0)
            return LocationProcessorTypes.CardPointe
        else
            return LocationProcessorTypes.Unknown            
    }

    serializeMerchantInfo() {
        if (this.locationProcessorType == LocationProcessorTypes.Chase)
            this.merchantInfo = JSON.stringify(this.chaseSettings!);
        else if (this.locationProcessorType == LocationProcessorTypes.CardPointe)
            this.merchantInfo = this.pineappleMerchantId!;
        else
            this.merchantInfo = null
 
    }

    static from(json: string): LocationModel {
        let model = Object.assign(new LocationModel(), json);        
        
        model.locationProcessorType = model._locationProcessorType

        if (model.locationProcessorType == LocationProcessorTypes.Chase)
            model.chaseSettings = JSON.parse(model.merchantInfo!);
        else if (model.locationProcessorType == LocationProcessorTypes.CardPointe)
            model.pineappleMerchantId = model.merchantInfo!;

        return model;
    }
}


class chaseSettingsModel {
    __private_id: string = "chase_setting_model"
    secureId: string = "";
    apiKey: string = "";
}